import { Table } from "antd";
import React from "react";

export const EmptyTable = ({ columns }: any) => {
  return <Table columns={columns} loading={true} />;
};
